import { CustomerModel } from "@models/customer/customerModel"

export class ApprovalConfigurationPositionModel {
  id: any
  name: any
  requestConfigurationId: any
  userIds?: any[]
  constructor() {
    this.id = undefined
    this.requestConfigurationId = undefined
    this.name = ""
    this.userIds = []
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ApprovalConfigurationPositionModel(), obj)

    newObj.flowId = obj.id
    newObj.id = obj.approvalPositionId // lấy id là approvalPositionId, update dùng approvalPositionId
    newObj.name = obj.approvalPosition?.name
    newObj.userIds = obj.approvalPosition?.userIds
    newObj.users = obj.approvalPosition?.approvalUsers?.map((item) => {
      return { id: item?.userId, name: item?.user?.displayName }
    })

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
export class ApprovalConfigurationModel {
  constructor() {}

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ApprovalConfigurationModel(), obj)

    newObj.data = ApprovalConfigurationPositionModel.assigns(obj.flows)

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class customerUpdateRequestModel {
  updateData?: any
  constructor() {
    this.updateData = {}
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new customerUpdateRequestModel(), obj)

    newObj.updateData = CustomerModel.assign(obj.updateData)

    newObj.data = CustomerModel.assign(obj.data)
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
